import videojs from 'video.js';

const Component = videojs.getComponent('Component');
const ClickableComponent = videojs.getComponent('ClickableComponent');

const defaultOptions = {
  handleClick: () => {},
};

export default class ButtonToggleMessanger extends ClickableComponent {
  constructor(player, options) {
    super(player, options);
    this.player = player;
    this.options = videojs.mergeOptions(defaultOptions, options);

    this.setListeners();
  }

  setListeners() {
    // Показываем/скрываем кнопку чата при изменении viewMode
    this.player.on('change-view-mode', () => {
      const viewMode = this.player.el().dataset.viewMode;
      const shouldShowButtonToggleMessanger = this.options.showButtonToggleMessangerOnDevices.includes(viewMode);

      shouldShowButtonToggleMessanger ? this.show() : this.hide();
    });
  }

  createEl() {
    const button = videojs.createEl('button', {
      className: 'vjs-chat-toggle vjs-chat-icon__toggle vjs-control vjs-button vjs-hidden',
    });
    const content = videojs.createEl('span', {
      className: 'vjs-icon-placeholder',
    });
    button.appendChild(content);
    return button;
  }

  handleClick() {
    this.options.handleClick();
  }

  ready() {
    if (this.el().classList.contains('vjs-chat-icon__toggle_active')) {
      this.player().el().classList.add('vjs-chat_visible');
    }
  }
}

Component.registerComponent('ButtonToggleMessanger', ButtonToggleMessanger);
